import { withAnalyticsTracking } from '../../../utils/withAnalyticsTracking'
import { StaticActionHandler } from '../actionHandlers'
import { TransactionsPaymentsActionType } from '../utils/getsPaymentsActions'

export const bankPaymentActionHandlers: Record<TransactionsPaymentsActionType, StaticActionHandler> = {
  [TransactionsPaymentsActionType.Void]: withAnalyticsTracking(
    ({ openModal, voidBillPaymentModalId }) => {
      openModal(voidBillPaymentModalId)
    },
    'Bank Payments',
    TransactionsPaymentsActionType.Void,
  ),
}
